<template>
  <footer class="footer">
    <div class="footer-container">

      <!-- IZQUIERDA -->
      <div class="footer-left">
        <img src="/image/logo.png" alt="GM Risk" class="logo" />

        <div class="social-icons">
          <a href="https://www.facebook.com/GmRiskseguros/" target="_blank">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://instagram.com/gmrisk1?igshid=a7wi22ev" target="_blank">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
      </div>

      <!-- CENTRO -->
      <div class="footer-center">
        <h3>DIRECCIÓN</h3>
        <p>
          Prolongación Paseo de Montejo 463A,<br>
          Colonia Itzimná, C.P. 97100
        </p>
      </div>

      <!-- DERECHA -->
      <div class="footer-right">
        <h3>CONTÁCTANOS</h3>
        <p>9993775400</p>
        <p>gmrisk7@gmail.com</p>
        <p><strong>Horario:</strong> 9:00 am a 6:00 pm</p>
      </div>

    </div>

    <!-- Bottom -->
    <div class="footer-bottom">
     <p>
      © 2025 GM Risk. Todos los derechos reservados. |
      
  
       <a href="/#/terminos-condiciones" class="footer-link">
         Términos y condiciones
       </a>
     
    </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Foter"
};
</script>

<style scoped>
.footer {
  background-color: #233d72;
  color: white;
  padding: 50px 20px 20px;
}
.footer-link {
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
}

.footer-link:hover {
  color: #ffffff;
  text-decoration: underline;
}
.footer-container {
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: start;
  gap: 40px;
}

/* IZQUIERDA */
.footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.logo {
  width: 180px;
}

/* ICONOS */
.social-icons {
  display: flex;
  justify-content: center;
  gap: 15px;
  width: 180px; /* mismo ancho que el logo */
}

.social-icons a {
  width: 45px;
  height: 45px;
  border: 1px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  transition: 0.3s;
}

.social-icons a:hover {
  background-color: white;
  color: #233d72;
}

/* CENTRO */
.footer-center {
  text-align: center;
}

.footer-center h3 {
  margin-bottom: 15px;
  color: #f5ac0f;
}

.footer-center p {
  line-height: 1.6;
  color: #e2e8f0;
}

/* DERECHA */
.footer-right {
  text-align: right;
}

.footer-right h3 {
  margin-bottom: 15px;
  color: #f5ac0f;
}

.footer-right p {
  margin: 5px 0;
  line-height: 1.5;
}

/* BOTTOM */
.footer-bottom {
  border-top: 1px solid rgba(255,255,255,0.2);
  margin-top: 30px;
  padding-top: 15px;
  text-align: center;
  font-size: 14px;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-left {
    align-items: center;
  }

  .footer-right {
    text-align: center;
  }
}
</style>